"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerPodBeanLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const PodcastPlayerPodBeanLink = ({ src }) => {
    return ((0, jsx_runtime_1.jsx)("a", { href: src, target: "_blank", className: "podcast-player-podbean__link text-icon-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-2xs flex h-10 w-10 items-center justify-center rounded-full", rel: "noreferrer noopener", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "open-in-new-outline" }) }));
};
exports.PodcastPlayerPodBeanLink = PodcastPlayerPodBeanLink;
